import { Component, OnInit, signal } from '@angular/core';
import { CertPolicies } from 'src/auth/cert-policies';
import { AuthService } from 'src/auth/services/auth.service';
import { ApplicationsClient, ProfessionalDevelopmentClient } from 'src/shared/services/api.service';
import { ConfigService } from 'src/shared/services/config.service';
import { FeatureManagementService } from 'src/shared/services/feature-management.service';

@Component({
  selector: 'cert-cert-nav-menu',
  templateUrl: './cert-nav-menu.component.html',
  styles: ``,
  standalone: false,
})
export class CertNavMenuComponent implements OnInit {
  canViewLab: boolean = this.authService.hasPolicy(CertPolicies.CanViewLab);
  canConfigureDenials: boolean = this.authService.hasPolicy(CertPolicies.CanConfigureDenials);
  canReviewDocuments: boolean = this.authService.hasPolicy(CertPolicies.CanReviewDocuments);
  canCreatePrintJobs: boolean = this.authService.hasPolicy(CertPolicies.CanCreatePrintJobs);
  canManageAdminQueue: boolean = this.authService.hasPolicy(CertPolicies.CanManageAdminQueue);
  canSelfAssignServiceItems: boolean = this.authService.hasPolicy(CertPolicies.CanSelfAssignServiceItems);
  mismatchedFingerprintsReportFeatureEnabled$ = this.featureManager.isFeatureEnabled('mismatchedFingerprintReport');
  acEvaluationEnabled$ = this.featureManager.isFeatureEnabled('acEvaluation');
  complexProfessionalDevelopmentEnabled = signal(false);
  professionalDevelopmentVerificationRequestsCount = signal(0);

  leaRushRequestsCount = signal(0);

  showServicesDropdown: boolean = this.canManageAdminQueue || this.canSelfAssignServiceItems;
  showEducatorsDropdown: boolean = this.canReviewDocuments || this.canCreatePrintJobs;
  showLabDropdown!: boolean;

  isProdEnvironment!: boolean;

  constructor(
    private readonly authService: AuthService,
    private readonly configService: ConfigService,
    private readonly featureManager: FeatureManagementService,
    private readonly applicationsClient: ApplicationsClient,
    private readonly professionalDevelopmentClient: ProfessionalDevelopmentClient,
  ) {}

  ngOnInit() {
    const environment = this.configService.config.environment;
    if (environment) {
      this.determineShowLabDropdown(environment);
    }
    this.applicationsClient.getTotalCountOfLeaRushRequests().subscribe((count) => {
      this.leaRushRequestsCount.set(count);
    });
    this.featureManager.isFeatureEnabled('complexProfessionalDevelopment').subscribe((enabled) => {
      this.complexProfessionalDevelopmentEnabled.set(enabled);
      if (enabled) {
        this.getProfessionalDevelopmentVerificationRequestsCount();
      }
    });
  }

  determineShowLabDropdown(environment: string) {
    this.isProdEnvironment = environment.toLowerCase() === 'prod';
    this.showLabDropdown = this.isProdEnvironment ? this.canConfigureDenials : this.canViewLab;
  }

  getProfessionalDevelopmentVerificationRequestsCount() {
    this.professionalDevelopmentClient.getProfessionalDevelopmentVerificationRequests().subscribe((requests) => {
      this.professionalDevelopmentVerificationRequestsCount.set(requests.length);
    });
  }
}
